import { deleteApiRequest } from 'api';

export const deleteCourse = (id: number): Promise<number> => {
    return deleteApiRequest(`/course/delete/${id}/`).then(() => id);
};
